import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import NewsletterSection from "@/components/NewsletterSection";
import { Reveal, Eyebrow } from "@/components/Motion";
import { ARTICLES } from "@/data/articles";
import { ArrowRight } from "lucide-react";

export default function Journal() {
    return (
        <>
            <SEO
                title="The Field Journal — Trout Fishing Articles & Guides"
                description="Keyword-rich trout fishing articles from the water: beginner fly fishing plans, hatch charts, and tactics — written by anglers, for anglers."
            />
            <section className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-44 pb-16" data-testid="journal-hero">
                <Reveal>
                    <Eyebrow>The Field Journal</Eyebrow>
                    <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-50 leading-[1.05]">
                        Notes from <span className="text-teal">cold water.</span>
                    </h1>
                    <p className="mt-6 font-body text-lg text-slate-400 max-w-2xl">
                        Long-form guides and river stories — the same knowledge as our field guides, slowed down and stretched out. New entries as the seasons turn.
                    </p>
                </Reveal>
            </section>

            <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 sm:pb-32" data-testid="journal-list">
                <div className="grid md:grid-cols-2 gap-6">
                    {ARTICLES.map((a, i) => (
                        <Reveal key={a.slug} delay={i * 0.1}>
                            <Link
                                to={`/journal/${a.slug}`}
                                data-testid={`journal-card-${a.slug}`}
                                className="group block rounded-2xl overflow-hidden border border-white/10 bg-[#111C2E] hover:border-teal/40 transition-colors duration-500"
                            >
                                <div className="aspect-[16/9] overflow-hidden">
                                    <img
                                        src={a.image}
                                        alt={a.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                    />
                                </div>
                                <div className="p-7">
                                    <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.24em] uppercase">
                                        <span className="text-teal">{a.category}</span>
                                        <span className="text-slate-500">{a.date}</span>
                                        <span className="text-slate-500">{a.readTime}</span>
                                    </div>
                                    <h2 className="mt-3 font-serif text-2xl sm:text-3xl font-semibold text-slate-50 leading-snug flex items-start gap-3">
                                        {a.title}
                                        <ArrowRight size={22} className="mt-1.5 shrink-0 text-teal opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500" />
                                    </h2>
                                    <p className="mt-3 font-body text-sm text-slate-400">{a.excerpt}</p>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>

            <NewsletterSection />
        </>
    );
}
